import * as React from "react";
const SvgFiRrPlaneProp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plane-prop_svg__a)">
      <path
        fill="#062147"
        d="M23.946 11.504C23.714 10.076 22.396 9 20.877 9l-5.141.013L14.853 5h1.148v1a1 1 0 1 0 2 0V2a1 1 0 1 0-2 0v1h-1.588l-.144-.652C13.973 1.007 12.805.042 11.332.002A2.504 2.504 0 0 0 9 2.489V3H8a1 1 0 1 0 0 2h1v4H5.537L4.234 7.032A2.3 2.3 0 0 0 2.309 6a2.313 2.313 0 0 0-2.31 2.31v7.381a2.316 2.316 0 0 0 2.324 2.31c.78 0 1.502-.39 1.931-1.042l1.285-1.958h3.46v4h-1a1 1 0 1 0 0 2h1v.51c0 1.354 1.062 2.45 2.506 2.493a3 3 0 0 0 2.762-2.341l.146-.662h1.585v1a1 1 0 1 0 2 0v-4a1 1 0 1 0-2 0v1h-1.144l.88-3.987 5.25-.013c.881 0 1.715-.386 2.286-1.058a3.01 3.01 0 0 0 .674-2.438zm-2.197 1.144a1 1 0 0 1-.765.353l-6.054.015a1 1 0 0 0-.974.784l-1.641 7.432c-.095.432-.474.751-.832.775a.497.497 0 0 1-.483-.496v-7.51a1 1 0 0 0-1-1H5c-.337 0-.651.17-.836.451l-1.58 2.408c-.141.213-.585.121-.584-.169V8.31c0-.275.417-.4.567-.172l1.599 2.414c.186.28.499.448.834.448h5a1 1 0 0 0 1-1V2.489c0-.258.205-.474.37-.489a1 1 0 0 1 .946.778l1.641 7.451a1 1 0 0 0 .977.785h.002l5.944-.015c.538 0 1.018.362 1.092.824.049.304-.03.596-.223.823z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plane-prop_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlaneProp;
